import { createSlice } from 'utils/@reduxjs/toolkit';
import { SelectedFiltersState } from './types';
import { reducers } from './reducers';

const transNo = { en: 'No', fr: 'Non', de: 'Nein', nl: 'Nee' };
const transNone = { en: 'None', fr: 'Aucune', de: 'Keine', nl: 'Geen' };
// Added as a part of hotfix to select as default for fr & de.

const urlParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlParams);

const lang =
  params && params.userLanguageCode
    ? params.userLanguageCode.toLowerCase()
    : 'en';

export const initialState: SelectedFiltersState = {
  1: {
    filter: {
      basicForm: 'ball_valve',
      attributes: [
        {
          attributeIdentifier: 'basicForm',
          displayName: 'Valve type',
          values: ['ball_valve'],
          inputType: 'radioGroup',
        },
      ],
    },
  },
  2: {
    filter: {
      basicForm: 'pneumatic_actuator',
      attributes: [
        {
          attributeIdentifier: 'basicForm',
          displayName: 'Actuator type',
          values: ['pneumatic_actuator'],
          inputType: 'radioGroup',
        },
        {
          attributeIdentifier: 'ActuatorFunction',
          displayName: 'Actuator function',
          values: ['double_acting'],
          inputType: 'radioGroup',
        },
        {
          attributeIdentifier: 'ActuatorMediumType',
          displayName: 'Medium type',
          values: ['Liquid'],
          inputType: 'radioGroup',
        },
        {
          attributeIdentifier: 'ActuatorSupplyPressure',
          displayName: 'Supply Pressure',
          values: ['6bar'],
          inputType: 'radioGroup',
        },
      ],
    },
  },
  3: {
    filter: {
      basicForm: 'monitoring',
      attributes: [
        {
          attributeIdentifier: 'EGTF_3734__STRING',
          displayName: 'Monitoring type',
          values: ['switchbox'],
          inputType: 'radioGroup',
        },
        {
          attributeIdentifier: 'EF000854__STRING',
          displayName: 'ATEX class',
          values: [transNone[lang]],
          inputType: 'radioGroup',
        },
      ],
    },
  },
  4: {
    filter: {
      basicForm: 'solenoid',
      attributes: [
        {
          attributeIdentifier: 'EF004663__STRING',
          displayName: 'ATEX class',
          values: [transNo[lang]],
          inputType: 'radioGroup',
        },
      ],
    },
  },
};

const slice = createSlice({
  name: 'selectedFilters',
  initialState,
  reducers,
});

export const { actions: selectedFiltersActions } = slice;
export const { reducer: selectedFiltersReducer } = slice;
